module.exports = __webpack_public_path__ + "fonts/subtract_2.svg";